<template>
  <el-drawer :visible.sync="drawer" size="700px" :with-header="false" :destroy-on-close="true">
    <div class="item-box-content" :productListName="productList">
      <div>
        <i class="el-icon-close" style="font-size:22px" @click="onClose"></i>
      </div>
      <div class="title-font-style" style="margin-top:20px;">
        <span>产品信息</span>
      </div>
      <el-table
        max-height="378"
        style="margin-top:20px;"
        border
        ref="tableRef"
        :data="list"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
      >
        <el-table-column show-overflow-tooltip prop="brandName" label="品牌"></el-table-column>
        <el-table-column show-overflow-tooltip prop="seriesName" label="系列"></el-table-column>
        <el-table-column show-overflow-tooltip prop="proName" label="产品名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="proType" label="型号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="orderNumber" label="订货号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="cbUnit" label="单位"></el-table-column>
        <el-table-column show-overflow-tooltip prop="count" label="数量">
          <template
            slot-scope="scope"
          >{{(scope.row.countAll)-(+scope.row.countUsed)-(+scope.row.countUsedAllot)}}</template>
        </el-table-column>
      </el-table>
      <div class="title-font-style" style="margin-top:20px;">
        <span>备货仓库库存</span>
      </div>
      <el-table
        max-height="378"
        style="margin-top:20px;"
        border
        ref="tableRef"
        :data="alternativeList"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
      >
        <el-table-column prop="storageName" show-overflow-tooltip label="仓库"></el-table-column>
        <el-table-column prop="shelvesName" show-overflow-tooltip label="货架"></el-table-column>
        <el-table-column prop="batchNumber" show-overflow-tooltip label="入库批次"></el-table-column>
        <el-table-column show-overflow-tooltip label="可备货库存" width="100px">
          <template slot-scope="scope">{{(scope.row.countMax)-(+scope.row.countUsed)}}</template>
        </el-table-column>
        <el-table-column label="备货数量" width="160px">
          <template slot-scope="scope">
            <el-input
              :disabled="(scope.row.countMax)-(+scope.row.countUsed)===0"
              @input="stockUpCount(scope.$index)"
              v-model.number="scope.row.stockupCount"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column v-if="$route.query.stockUpType==='入库备货'" label="采购单价">
          <template slot-scope="scope"><span>{{scope.row.unitPrice |priceFilterNum }}</span></template>
        </el-table-column>
      </el-table>
      <div style="float:right;padding:10px;">备货总数 : {{ counts }}</div>
      <div class="title-font-style" style="margin-top:20px;">
        <span>其他仓库库存</span>
      </div>
      <el-table
        max-height="378"
        style="margin-top:20px;"
        border
        ref="tableRef"
        :data="otherList"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
      >
        <el-table-column
          prop="storageName"
          label="仓库"
          :filters="warehouse"
          :filter-method="filterHandler"
          v-if="otherList.length>0"
        ></el-table-column>
        <el-table-column prop="storageName" show-overflow-tooltip label="仓库" v-else></el-table-column>
        <el-table-column prop="shelvesName" show-overflow-tooltip label="货架"></el-table-column>
        <el-table-column prop="batchNumber" show-overflow-tooltip label="入库批次"></el-table-column>
        <el-table-column label="可备货库存" width="100px">
          <template slot-scope="scope">{{(scope.row.countMax)-(+scope.row.countUsed)}}</template>
        </el-table-column>
        <el-table-column label="备货数量" width="160px">
          <template slot-scope="scope">
            <el-input
              :disabled="(scope.row.countMax)-(+scope.row.countUsed) === 0"
              @input="allotCount(scope.$index)"
              v-model.number="scope.row.stockupCount"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column v-if="$route.query.stockUpType==='入库备货'" label="采购单价">
          <template slot-scope="scope"><span>{{scope.row.unitPrice |priceFilterNum }}</span></template>
        </el-table-column>
      </el-table>
      <div class="allotCounts">调拨总数 : {{ allotCounts }}</div>
      <div class="allotCounts-text">说明 : 未备货产品将默认移入采购备货区</div>

      <el-row style="margin-top:20px;">
        <el-col :span="24" style="text-align:center;">
          <el-button @click="onSubmit(productList)" type="primary">确认备货</el-button>
          <el-button @click="onClose">取消方案</el-button>
        </el-col>
      </el-row>
    </div>
    <!------------ 确认备货 ------------>
    <open-or-close-dialog
      ref="openOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close-dialog>
  </el-drawer>
</template>
<script>
import OpenOrClose from '@/components/OpenOrClose/index'
export default {
  components: {
    'open-or-close-dialog': OpenOrClose
  },
  props: ['productListName'],
  data() {
    return {
      list: [], // 产品信息List数据
      alternativeList: [], // 备货仓库的List数据
      otherList: [], // 其他仓库的List数据
      val: {},
      warehouse: [], // 调拨仓库筛选
      index: '', // 索引
      allotCounts: 0, // 备货仓库备货总数
      counts: 0, // 调拨仓库总数
      drawer: false, // 开关
      title: '',
      content: '',
      productList: {
        orderContractStockupShelveListVo: {
          orderContractStockupShelvesVoList: [],
          orderContractStockupShelvesVos: []
        }
      }
    }
  },
  watch: {},
  mounted() {
    this.counts = 0 // 价格初始为零
    this.allotCounts = 0 // 价格初始为零
  },
  methods: {
    filterHandler(value, row, column) {
      // 过滤器
      const property = column.property
      return row[property] === value
    },

    allotCount(index) {
      // 调拨仓库数量Change
      if (isNaN(this.otherList[index].stockupCount) || this.otherList[index].stockupCount === '') {
        this.otherList[index].stockupCount = 0
      } else {
        this.otherList[index].stockupCount = parseFloat(this.otherList[index].stockupCount)
        if (
          this.otherList[index].stockupCount >
          this.otherList[index].countMax - this.otherList[index].countUsed
        ) {
          this.$message.error('可用数量不足！') // 数量不足
          this.otherList[index].stockupCount =
            +this.otherList[index].countMax - +this.otherList[index].countUsed
        }
      }
      this.allotCounts = 0
      this.otherList.map(item => {
        this.allotCounts += +item.stockupCount // 计算调拨总数
      })
    },

    stockUpCount(index) {
      // 备货仓库数量Change
      const params = this.alternativeList[index]
      if (isNaN(params.stockupCount) || params.stockupCount === '') {
        params.stockupCount = 0
      } else {
        if (parseFloat(params.stockupCount) > +params.countMax - +params.countUsed) {
          this.$message.error('可用数量不足！')
          params.stockupCount = +params.countMax - +params.countUsed
        }
      }
      this.counts = 0
      this.alternativeList.map(item => {
        this.counts += +item.stockupCount /// 计算备货总数
      })
    },

    onInitial(row, index) {
      // 库存详情弹窗初始化
      this.index = index // 索引
      this.counts = 0 // 价格初始为零
      this.allotCounts = 0 // 价格初始为零
      this.productList = JSON.parse(JSON.stringify(row)) // 深clone数据
      this.list = [this.productList.orderContractStockupVo] // 产品信息List数据
      this.alternativeList = this.productList.orderContractStockupShelveListVo.orderContractStockupShelvesVos // 备货仓库的List数据
      this.alternativeList.forEach(element => {
        element.stockupCount = 0
      }) // 添加数量字段
      this.otherList = this.productList.orderContractStockupShelveListVo.orderContractStockupShelvesVoList // 其他仓库的List数据
      this.otherList.forEach(element => {
        element.stockupCount = 0
      }) // 添加数量字段
      this.warehouse = [] // 调拨仓库筛选list
      this.productList.warehouse.forEach(element => {
        const data = {
          text: element,
          value: element
        }
        this.warehouse.push(data)
      })
      this.drawer = true // drawer打开
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },

    onClose() {
      // 关闭
      this.drawer = false
    },
    onSubmit(val) {
      // 确定备货
      const data = val.orderContractStockupVo
      if (data.countAll - data.countUsed - data.countUsedAllot < this.allotCounts + this.counts) {
        this.$message.error('仓库备货和调拨备货总数不能超过备货总量')
      } else {
        if (this.allotCounts > 0) {
          this.title = '确认备货'
          this.content =
            '当前产品备货方案中包含调拨备货，如存在未备货产品则默认移入采购备货区，是否确认方案？'
          this.$refs.openOrCloseRefs.onInitial(val)
        } else {
          this.title = '确认备货'
          this.content =
            '是否确认当前备货方案，如存在未备货产品则默认移入采购备货区，是否确认方案？'
          this.$refs.openOrCloseRefs.onInitial(val)
        }
      }
    },
    // 再次确认备货
    onUpdataState() {
      this.drawer = false // 关闭drawer
      const dataList = this.productList.orderContractStockupVo
      dataList.countUsed = dataList.countUsed + (this.allotCounts + this.counts)
      this.alternativeList.forEach(element => {
        element.countUsed = element.countUsed + element.stockupCount
        element.stockupCount = 0
      })
      this.otherList.forEach(element => {
        element.countUsed = element.countUsed + element.stockupCount
        element.stockupCount = 0
      })
      this.$emit('payableDrawer', this.productList, this.index, this.allotCounts + this.counts)
    }
  }
}
</script>
<style lang="scss" scoped>
.allotCounts {
  float: right;
  padding: 10px;
}
.allotCounts-class {
  float: left;
  padding-top: 50px;
  padding-bottom: 50px;
}
</style>
